// @ts-check
import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import Link from '~/components/Common/Link';
import BynderSimpleImage from './BynderSimpleImage';

import './PersonnelInfo.scss';

export const query = graphql`
	fragment PersonnelInfoFragment on Ozk_content_blockModular_blocksCopyContent {
		personnel_info {
			avatar {
				...BynderImageFragment
			}
			full_name
			title
			address_line
			include_red_line
			phone {
				title
				href
			}
			email {
				title
				href
			}
			website {
				title
				href
			}
		}
	}
`;

/**
 * @typedef PersonnelInfoOptions
 * @property {string[]} address_line
 * @property {import('../CSTypes').BynderImageOptions[]} [avatar]
 * @property {import('../CSTypes').CSLink} email
 * @property {string} full_name
 * @property {import('../CSTypes').CSLink} phone
 * @property {import('../CSTypes').CSLink} website
 * @property {string[]} title
 * @property {boolean} [include_red_line=false]
 * @property {boolean} [include_phone_icon=false]
 *
 * @typedef PersonnelInfoProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<PersonnelInfoOptions>} [options]
 */
/** @type {import('~/types/React').ReactFC<PersonnelInfoProps>} */
const PersonnelInfo = ({ options, ...rest }) => {
	if (!options) {
		return null;
	}

	return (
		<div {...rest} className={classNames(rest.className, 'personnel-info')}>
			{!!options.avatar?.[0] && <BynderSimpleImage option={options.avatar?.[0]} type="img" />}
			{!!options.full_name && <p className="full-name">{options.full_name}</p>}
			{options.title?.map((t, i) => (
				<p className="title" key={i}>
					{t}
				</p>
			))}
			{options.address_line?.map((a, j) => (
				<p className="address-line" key={j}>
					{a}
				</p>
			))}
			{}
			{!!options.phone?.href && options.phone?.title && (
				<Link className={classNames('phone', { 'with-red': options.include_red_line })} to={options.phone.href}>
					<span className="phone-title">
						{options.include_phone_icon && <i className="icon">phone</i>}
						<>{options.phone.title}</>
					</span>
				</Link>
			)}
			{!!options.email?.href && !!options.email.title && (
				<Link className="email" to={options.email.href}>
					{options.email.title}
				</Link>
			)}
			{!!options.website?.href && !!options.website.title && (
				<Link className="website" to={options.website.href}>
					{options.website.title}
				</Link>
			)}
		</div>
	);
};

export default PersonnelInfo;
